import React, { useEffect } from 'react';

const APP_DEEP_LINK = 'pedalxchange://signup?emailVerified=true';

// Native signups finish email verification in an external browser. This page is
// the continue-URL target for native; it deep-links the user back into the app,
// which then auto-advances to the phone step. Web signups never land here.
const EmailVerified = () => {
  const openApp = () => {
    window.location.href = APP_DEEP_LINK;
  };

  // Best-effort auto-launch on mobile only. Most mobile browsers require a tap
  // for custom schemes (and iOS shows an "Open in PedalxChange?" prompt), so the
  // button below is the primary path. We skip desktop because an unhandled
  // custom scheme there can surface a "no app to open this address" dialog.
  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '');
    if (!isMobile) return;
    const t = setTimeout(openApp, 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{
      minHeight: '60vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      padding: '24px', maxWidth: '480px', margin: '0 auto'
    }}>
      <div style={{
        width: '64px', height: '64px', borderRadius: '50%',
        backgroundColor: '#d4edda', color: '#155724',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '34px', marginBottom: '20px'
      }}>✓</div>

      <h1 style={{ fontSize: '24px', margin: '0 0 10px', color: '#1f2937' }}>
        Email verified!
      </h1>
      <p style={{ fontSize: '16px', color: '#4b5563', margin: '0 0 24px', lineHeight: 1.5 }}>
        Your email is confirmed. Tap below to return to the PedalxChange app and
        finish setting up your account.
      </p>

      <button
        onClick={openApp}
        style={{
          backgroundColor: '#C9A227', color: '#fff', border: 'none',
          borderRadius: '8px', padding: '14px 28px', fontSize: '16px',
          fontWeight: 600, cursor: 'pointer', width: '100%', maxWidth: '320px'
        }}
      >
        Return to the PedalxChange app
      </button>

      <p style={{ fontSize: '13px', color: '#9ca3af', marginTop: '18px', lineHeight: 1.5 }}>
        If nothing happens, switch back to the PedalxChange app manually to
        continue. On a computer? Open the app on your phone to finish.
      </p>
    </div>
  );
};

export default EmailVerified;
